const URLS_TO_PURGE = {
  TEAM_BUSTER: ["GET_USER_TEAM"],
};

export const TEAM_BUSTER = "TEAM_BUSTER";
export const LEAGUE_BUSTER = "LEAGUE_BUSTER";
export const HOME_BUSTER = "HOME_BUSTER";
